<template>
  <div class="literature">
    <div class="title">
      <div class="left">
        <i></i>
        <p>细胞鉴定相关文献下载区</p>
      </div>
      <router-link :to="$Router.literature.path"
                   class="more"
                   tag="a"
                   rel="nofollow">更多>></router-link>
    </div>
    <router-link :to="{
        path: $Router.literaturecontent.path,
        query: {
          id: item.id,
        },
      }"
                 class="top"
                 v-for="(item, index) in list.slice(0, 1)"
                 :key="index">
      <div class="img"
           v-if="item.cover_img">
        <img :src="item.cover_img"
             alt="" />
      </div>
      <div class="text">
        <div class="texttitle">{{ item.title }}</div>
        <div class="info">{{ item.description }}...</div>
      </div>
    </router-link>
    <div class="item">
      <router-link :to="{
          path: $Router.literaturecontent.path,
          query: {
            id: item.id,
          },
        }"
                   v-for="(item, index) in list.slice(1, 4)"
                   :key="index">
        <i></i>
        <p>{{ item.title }}</p>
      </router-link>
    </div>
  </div>
</template>

<script>
import service from './literature.js'

export default {
  name: 'literature',
  data () {
    return {
      limit: 6,
      total: 0,
      page: 1,
      list: []
    }
  },
  created () {
    service.getWebArticleList(this)
  }
}
</script>

<style lang="scss" scoped>
@import './literature';
</style>



// WEBPACK FOOTER //
// src/components/index/literature/literature.vue